import React from "react";
import { Button, SxProps, Theme } from "@mui/material";

import { AppTheme } from "Utils/theme";

interface IProps {
  label: string;
  type?: string; 
  disabled?: boolean;
  variant: "outlined" | "contained" | "text";
  buttonColor?: string;
  labelColor?: string;
  onBtnClick: (e: any) => void;
  uppercase: boolean;
  buttonnSize: "sm" | "md" | "lg";
  buttonContainerStyle?: SxProps<Theme>;
}

export const RectangleButton = (props: IProps) => {
  const {
    label,
    disabled,
    variant,
    buttonColor,
    labelColor,
    onBtnClick,
    uppercase,
    buttonnSize,
    buttonContainerStyle,
    type
  } = props;

  const buttonSize = (size: "sm" | "md" | "lg") => {
    return {
      sm: "25%",
      md: "50%",
      lg: "100%",
    }[size];
  };
  return (
    <Button
      variant={variant}
      disabled={disabled}
      onClick={onBtnClick}
      sx={{
        backgroundColor: buttonColor,
        margin: `${AppTheme.spacing.space12}px 0px`,
        textTransform: uppercase ? "uppercase" : "none",
        width: buttonSize(buttonnSize),
        alignSelf: "center",
        ...buttonContainerStyle,
        color: labelColor
      }}
    >
      {label}
    </Button>
  );
};
